import { ButtonHTMLAttributes, ReactNode } from "react";
import cn from "classnames";
import Tooltip, { TooltipPosition } from "./Tooltip";
import { useIsMobile } from "../../hooks/useIsMobile";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  isActive?: boolean;
  description?: string;
  tooltipPosition?: TooltipPosition;
}

export default function IconButton({
  children,
  className,
  disabled,
  isActive,
  description,
  tooltipPosition,
  ...props
}: IconButtonProps) {
  const isMobile = useIsMobile();
  const button = (
    <button
      className={cn(
        className,
        // Padding steps up at xl rather than jumping straight to p-2 at md:
        // between those widths (a laptop at 150% browser zoom sits at ~1152px)
        // the editor toolbar's 15 buttons need ~58px more than the column has,
        // and p-1.5 gives that back without shrinking the icons themselves.
        "btn border-0 hover:bg-blue-100 dark:hover:bg-blue-900/60 p-1 md:p-1.5 xl:p-2 m-[1px] h-auto min-h-0 shadow-none",
        {
          "bg-blue-100 dark:bg-blue-900/60": isActive,
          "bg-base-300 text-base-content/40 pointer-events-none": disabled,
        }
      )}
      {...props}
    >
      {children}
    </button>
  );

  return description && !isMobile ? (
    <Tooltip placement={tooltipPosition} overlay={description}>
      {button}
    </Tooltip>
  ) : (
    button
  );
}
